/**
 * Helper
 */
export default class Helper {
    /**
     * Sleeps helper
     * @param ms
     * @returns
     */
    static async sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
//# sourceMappingURL=helper.js.map